import { loadStripe } from '@stripe/stripe-js';

// Replace with your Stripe publishable key
const devKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_DEV
const prodKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD
const key = process.env.NODE_ENV === 'production' ? prodKey : devKey;
export const stripePromise = loadStripe(key);